import React from 'react';
import PropTypes from 'prop-types';
import { fromGlobalId } from 'graphql-relay';
import { FormattedMessage, defineMessages } from 'react-intl';

import get from 'lodash/get';
import FairAvailability from '../FairAvailability';
import FairRequest from '../FairRequest';

import Item from '../../components/Item';
import Segment from '../../components/Segment';

import './styles.css';

const messages = defineMessages({
  noFairs: {
    id: 'fairs-availability.noneFound',
    defaultMessage: 'There are currently no fairs posted for this high school.',
  },
});

function getCollegeFairs(highSchool) {
  const collegeFairs = get(highSchool, 'collegeFairs.edges');
  if (!collegeFairs || collegeFairs.length === 0) {
    return null;
  }

  return collegeFairs.map((collegeFair) => collegeFair.node);
}

class FairsAvailability extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    highSchoolBySchoolId: PropTypes.object,
    viewer: PropTypes.object,
  };

  state = {
    open: false,
  };

  open = (highSchoolName, fairNode) => {
    this.setState({ open: true, highSchoolName, fairNode });
  };

  close = () => {
    this.setState({ open: false });
  };

  render() {
    const { highSchoolBySchoolId, viewer } = this.props;
    const schoolName = get(highSchoolBySchoolId, 'name');
    const collegeFairs = getCollegeFairs(highSchoolBySchoolId);
    const { highSchoolName, fairNode } = this.state;

    const institutionType = get(viewer, 'institution.field_he_control');

    if (!collegeFairs) {
      return (
        <Segment>
          <Item.Group>
            <Item>
              <Item.Content>
                <Item.Header>{schoolName}</Item.Header>
                <Item.Description>
                  <FormattedMessage {...messages.noFairs} />
                </Item.Description>
              </Item.Content>
            </Item>
          </Item.Group>
        </Segment>
      );
    } else {
      const primaryContact = get(highSchoolBySchoolId, 'repVisitsAccount.collegeFairsPrimaryContact', {});
      const address = get(highSchoolBySchoolId, 'address');
      const schoolAddress = {
        zip: get(address, 'field_hs_eln_zip'),
        city: get(address, 'field_hs_elna_city'),
        state: get(address, 'field_hs_elna_state_latest'),
        street: get(address, 'field_hs_elna_address_line1'),
      };

      const schoolPhone = get(highSchoolBySchoolId, 'naviance.field_hs_elna_phone');
      const allowForProfit = get(highSchoolBySchoolId, 'repVisitsAccount.allowForProfit');
      const schoolId = fromGlobalId(highSchoolBySchoolId.id).id;

      return (
        <div styleName="visits-fair-container" data-cy="visitsAndFairsContainer">
          {highSchoolName && fairNode && (
          <FairRequest
            highSchoolName={highSchoolName}
            fairNode={fairNode}
            open={this.state.open}
            onClose={this.close}
          />
          )}
          {collegeFairs.map((collegeFair, index) => (
            <Segment key={collegeFair.id}>
              <FairAvailability
                schoolId={schoolId}
                schoolName={schoolName}
                schoolPhone={schoolPhone}
                schoolAddress={schoolAddress}
                primaryContact={primaryContact}
                collegeFair={collegeFair}
                onRegister={this.open}
                allowForProfit={allowForProfit}
                institutionType={institutionType}
              />
            </Segment>
          ))}
        </div>
      );
    }
  }
}

export default FairsAvailability;
